function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { commonStyles } from '../styles';
export var tabs = function tabs(props, hasPadding) {
  var vertical = props.vertical;
  return [vertical ? {
    display: 'flex',
    alignItems: 'flex-start'
  } : {
    width: '100%'
  }, hasPadding && {
    '& > .tabs-content': {
      padding: vertical ? '0 0 0 24px' : '24px 0 0'
    }
  }].concat(_toConsumableArray(commonStyles(props)));
};
export var tabsListContainer = function tabsListContainer(vertical) {
  return function (theme) {
    return _objectSpread({
      display: 'flex',
      flexFlow: vertical ? 'column nowrap' : 'row wrap',
      width: vertical ? 'auto' : '100%',
      backgroundColor: theme.white,
      position: 'relative',
      zIndex: 500
    }, !vertical && {
      borderBottom: "1px solid ".concat(theme.gray100)
    });
  };
};
export var tabContainer = function tabContainer(props) {
  return function (theme) {
    var pills = props.pills,
        vertical = props.vertical;
    return [{
      display: 'inline-flex',
      cursor: 'pointer',
      padding: vertical ? '1.2em 2em' : '1em 2em',
      color: theme.gray300,
      transition: 'all .2s ease-in-out',
      marginBottom: vertical ? pills ? 8 : 0 : -1,
      position: 'relative',
      borderRadius: pills ? 8 : 0,
      fontWeight: 600,
      '&:hover': {
        color: theme.gray600
      },
      '&.active': pills ? {
        backgroundColor: theme.primary,
        color: theme.white
      } : vertical ? {
        color: theme.gray800,
        borderRight: "2px solid ".concat(theme.primary)
      } : {
        color: theme.gray800,
        '&:before': {
          transform: 'scaleX(1)',
          backgroundColor: theme.primary
        }
      }
    }, pills && !vertical && {
      marginRight: 8
    }, vertical && !pills && {
      borderRight: "2px solid ".concat(theme.gray200)
    }, vertical && {
      wordWrap: 'break-word',
      maxWidth: 200
    }, !pills && !vertical && {
      '&:before': {
        position: 'absolute',
        top: 'auto',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 2,
        content: "''",
        transition: 'all 0.4s',
        backfaceVisibility: 'hidden',
        transform: 'scaleX(0)'
      }
    }].concat(_toConsumableArray(commonStyles(props)));
  };
};